import React from 'react'
import { Document } from '@/payload-types'
import { RichText } from '@payloadcms/richtext-lexical/react'
import Link from 'next/link'
import { isMedia } from '@/lib/utils'

interface DocumentDetailProps {
  document: Document
}

const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Ko'
  const k = 1024
  const sizes = ['Ko', 'Mo', 'Go', 'To']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Number.parseFloat((bytes / Math.pow(k, i + 1)).toFixed(2)) + ' ' + sizes[i]
}

function DocumentDetail({ document }: Readonly<DocumentDetailProps>) {
  return (
    <>
      <section className="max-w-4xl mx-auto p-4 prose prose-neutral">
        {document.content && <RichText data={document.content} />}
      </section>
      {document.files && document.files.length > 0 ? (
        <ul className="max-w-4xl mx-auto w-full p-4">
          {document.files.map(
            (item) =>
              isMedia(item) && (
                <li key={item.id} className="flex flex-row items-center py-2 gap-2 border-t">
                  <Link href={String(item.url)} className="flex flex-row gap-2">
                    {item.alt ? <span className="font-semibold">{item.alt}</span> : null}
                    <span className="font-light">{item.filename}</span>
                  </Link>
                  {item.filesize ? (
                    <div className="flex flex-row gap-2 text-sm ml-auto">
                      <span>{formatFileSize(item.filesize)}</span>
                    </div>
                  ) : null}
                </li>
              ),
          )}
        </ul>
      ) : null}
    </>
  )
}

export { DocumentDetail }
